import type {
  GetSkinAnalysisRecommendationsPathParams,
  GetSkinAnalysisReportPathParams,
  GetSkinAnalysisResultStatusPathParams,
} from './types';
import type { Currency } from '../../../constants/currency/currency';

export const SKIN_ANALYSIS_QUERY_KEYS = {
  default: () => ['skinAnalysis'] as const,

  // queries
  getMyStatus: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getMyStatus'] as const,
  getMyOverview: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getMyOverview'] as const,
  // Currency is part of the key, not just the request: it changes the budget question's
  // labels, so two regions are two different survey payloads and must not share a cache entry.
  getActiveSurvey: (currency?: Currency) =>
    [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getActiveSurvey', currency ?? null] as const,
  getMySurvey: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getMySurvey'] as const,
  getLocation: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getLocation'] as const,
  getEnvironment: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getEnvironment'] as const,
  getResultStatus: ({ resultId }: GetSkinAnalysisResultStatusPathParams) =>
    [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getResultStatus', resultId] as const,
  getReport: ({ resultId }: GetSkinAnalysisReportPathParams) =>
    [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getReport', resultId] as const,
  getRecommendations: ({ resultId }: GetSkinAnalysisRecommendationsPathParams) =>
    [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'getRecommendations', resultId] as const,

  // mutations
  searchLocations: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'searchLocations'] as const,
  submitSurveyResponse: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'submitSurveyResponse'] as const,
  putLocation: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'putLocation'] as const,
  createImageUploadUrl: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'createImageUploadUrl'] as const,
  createResult: () => [...SKIN_ANALYSIS_QUERY_KEYS.default(), 'createResult'] as const,
};
